import { render, staticRenderFns } from "./VFormTemplateListItem.vue?vue&type=template&id=f51fe4ea&scoped=true"
import script from "./VFormTemplateListItem.vue?vue&type=script&lang=js"
export * from "./VFormTemplateListItem.vue?vue&type=script&lang=js"
import style0 from "./VFormTemplateListItem.vue?vue&type=style&index=0&id=f51fe4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51fe4ea",
  null
  
)

export default component.exports